module.exports = __webpack_public_path__ + "img/si-glyph-mail-white.386defa7.svg";